import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompressArrowsAlt, faExpandArrowsAlt } from "@fortawesome/free-solid-svg-icons";
import { Button } from "aible";
import RelationLineage from "components/Tiles/Sense/Relation/RelationLineage";
import ClockIcon from "images/SenseIcons/clock-rotate-left-light 1.svg";
import styles from "./style.module.css";
import { useDispatch, useSelector } from "types/store";
import { getIsOpenDataValidation, getIsOpenLineage, getIsOpenSettings } from "containers/Sense/dataset-selectors";
import { updateTileState } from "containers/Sense/reducer";
import { getDataset } from "containers/Home/reducer";
const LineagePanel = ({ datasetId, onSubmit, isSingleCol }) => {
    const dispatch = useDispatch();
    const dataset = useSelector((state) => getDataset(state, datasetId));
    const isOpenSettings = useSelector((state) => getIsOpenSettings(state, datasetId));
    const isOpenDataValidation = useSelector((state) => getIsOpenDataValidation(state, datasetId));
    const isOpenLineage = useSelector((state) => getIsOpenLineage(state, datasetId));
    const updateIsOpenLineage = (isOpenLineage) => {
        dispatch(updateTileState(datasetId, { isOpenLineage }));
    };
    return (React.createElement("div", { className: isOpenLineage ? styles.openOverview : styles.overview, style: {
            maxHeight: isOpenLineage ? "500px" : "190px",
            width: isSingleCol
                ? "100%"
                : isOpenSettings
                    ? "100%"
                    : isOpenLineage
                        ? "100%"
                        : isOpenDataValidation
                            ? "calc(50% - 15px)"
                            : "calc(33.333% - 14px)",
            overflow: isOpenLineage ? "auto" : "auto",
            marginLeft: isSingleCol || isOpenSettings || isOpenLineage ? "10px" : "0px"
        }, onClick: isOpenLineage !== true ? () => updateIsOpenLineage(!isOpenLineage) : undefined, id: "lineage_" + dataset?.id },
        React.createElement("div", { className: styles.senseTitle },
            React.createElement("div", { className: styles.sTitle },
                React.createElement("span", { className: styles.sIcon },
                    React.createElement("img", { src: ClockIcon, style: { height: "16px", width: "16px" } })),
                React.createElement("span", null, "Lineage/Usage")),
            isOpenLineage ? (React.createElement("div", { className: styles.closeButton, onClick: () => updateIsOpenLineage(!isOpenLineage) },
                React.createElement(Button, { style: { padding: "3px" } },
                    React.createElement("div", { className: styles.selIcon, title: "Close" },
                        React.createElement(FontAwesomeIcon, { icon: faCompressArrowsAlt }))))) : (React.createElement("div", { className: styles.selIcon + " " + styles.expandIcon },
                React.createElement(FontAwesomeIcon, { icon: faExpandArrowsAlt })))),
        React.createElement("div", { className: styles.updateTiles },
            React.createElement("div", { className: styles.tileFlex },
                React.createElement("div", { className: styles.tTop },
                    React.createElement("span", { title: moment.utc(dataset.updated_date).local().format("MMMM Do YYYY, h:mm:ss a") }, moment.utc(dataset.updated_date).local().fromNow())),
                React.createElement("div", { className: styles.tBot }, "LAST UPDATE"))),
        isOpenLineage && (React.createElement(RelationLineage, { datasetId: dataset.id, onSubmit: onSubmit, defaultOpenLineageSection: "prior" }))));
};
export default LineagePanel;
